import { render, staticRenderFns } from "./AdminRestartImport.vue?vue&type=template&id=1cd8aff9&"
import script from "./AdminRestartImport.vue?vue&type=script&lang=ts&"
export * from "./AdminRestartImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports